<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions_left">
					<!--임시저장-->
					<!-- <sf-button size="sm" v-if="rtnPartInfo.btnTsAuth1" line icon="file" :onClick="tmpSaveAction">
						{{ getMessage_('QWCC001004') }}
					</sf-button> -->
					<!--신청 AP-->
					<sf-button size="sm" v-if="rtnPartInfo.btnApAuth1" line icon="round-check-on" :onClick="ApcnAction">
						{{ getMessage_('QWCC001005') }}
					</sf-button>

					<!--확인완료 IC-->
					<sf-button size="sm" v-if="rtnPartInfo.btnApprAuth && !this.isMqyStation" line icon="round-check-on" :onClick="CmplAction" >
						{{ getMessage_('QWCC001286') }}
					</sf-button>
				</div>
			</div>
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001274') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 신청자 -->
							<th class="col-1">* {{ getMessage_('QWCC001251') }}</th>
							<td class="col-1">
								<el-input :value="rtnPartInfo.aplcNm" maxlength="6" readonly />
							</td>
							<!-- 신청부서 -->
							<th class="col-1">{{ getMessage_('QWCC001253') }}</th>
							<td class="col-1">
								<el-input :value="rtnPartInfo.aplcDeptNm" maxlength="6" readonly />
							</td>
							<!--신청일자-->
							<th class="col-1">{{ getMessage_('QWCC001252') }}</th>
							<td class="col-1"><el-input :value="rtnPartInfo.aplcDd" readonly /></td>
							<!--회수방법-->
							<th class="col-1">* {{ getMessage_('QWCC001906') }}</th>
							<td class="col-1">
								<el-select v-model="rtnPartInfo.clctWay" @change="changeClctWay" :disabled="rtnPartInfo.readOnlyAuth1">
									<el-option :label="getMessage_('QWCC001906')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in clctWayList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<!--신청자연락처-->
							<th class="col-1">* {{ getMessage_('QWCC001255') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.aplcTel"
									maxlength="20"
									@input="val => onChangeSelect(val, 'aplcTel')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
							<!--신청자회사명-->
							<th class="col-1">{{ getMessage_('QWCC001256') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.aplcCo"
									maxlength="30"
									@input="val => onChangeSelect(val, 'aplcCo')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
							<!--건의사항-->
							<th class="col-1">{{ getMessage_('QWCC001081') }}</th>
							<td class="col-1" colspan="3">
								<el-input
									:value="rtnPartInfo.sgtn"
									maxlength="330"
									@input="val => onChangeSelect(val, 'sgtn')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
						</tr>
						<tr>
							<!--수신자-->
							<th class="col-1">* {{ getMessage_('QWCC001257') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.rcptNm"
									maxlength="6"
									@input="val => onChangeSelect(val, 'rcptNm')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
							<!--수신자 연락처-->
							<th class="col-1">* {{ getMessage_('QWCC001258') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.rcptTel"
									maxlength="20"
									@input="val => onChangeSelect(val, 'rcptTel')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
							<!--택배회사-->
							<th class="col-1">{{ getMessage_('QWCC001259') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.dlvsCpnyNm"
									maxlength="6"
									@input="val => onChangeSelect(val, 'dlvsCpnyNm')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
							<!--확인완료일-->
							<th class="col-1">{{ getMessage_('QWCC001231') }}</th>
							<td class="col-1">
								<el-input :value="rtnPartInfo.cmplDd" maxlength="330" :placeholder="getMessage_('QWCC001231')" readonly />
								<!-- @input="val => onChangeSelect(val, 'cmplDd')" 
								:readonly="rtnPartInfo.readOnlyAuth1"-->
							</td>
						</tr>
						<tr>
							<!--주의사항-->
							<th class="col-1">{{ getMessage_('QWCC001260') }}</th>
							<td class="col-1" colspan="7">
								<el-input
									:value="rtnPartInfo.pctn"
									maxlength="330"
									@input="val => onChangeSelect(val, 'pctn')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
						</tr>
						<tr>
							<!--수신주소-->
							<th class="col-1">* {{ getMessage_('QWCC001261') }}</th>
							<td class="col-1" colspan="7">
								<el-input
									:value="rtnPartInfo.rcpnAdr"
									maxlength="330"
									@input="val => onChangeSelect(val, 'rcpnAdr')"
									:readonly="rtnPartInfo.readOnlyAuth1"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				rcpnAdr: yup //수신주소
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001261')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001261')])),
				// dlvsCpnyNm: yup //택배회사
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001259')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001259')])),
				rcptTel: yup //수신자 연락처
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001258')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001258')])),
				rcptNm: yup //수신자
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001257')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001257')])),
				aplcTel: yup //신청자연락처
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001255')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001255')])),
				clctWay: yup //회수상태
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001906')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001906')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeSelect(value, key) {
			if (key === 'rcptTel') {
				value = value?.length > 60 ? value.slice(0, 60) : value;
			}
			this.setRtnPartInfo_({ key, value });
		},

		changeClctWay(value) {
			//회수상태
			this.setRtnPartInfo_({ key: 'clctWay', value });
			this.rtnPartInfo.clctWay == '20'
				? this.setRtnPartInfo_({ key: 'dlvfYn', value: '' })
				: this.setRtnPartInfo_({ key: 'dlvfYn', value: 'Y' });
		},
		tmpSaveAction() {
			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);
			const saveParams = this.rtnPartInfo;
			const params = { saveParams: saveParams };
			await this.SaveRtnPartInfo_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			const rtnPartInfo = this.rtnPartInfo;
			await this.getRtnPartInfo_(rtnPartInfo);
			this.$sf_toggleLoading(false);
		},
		ApcnAction() {
			try {
				const saveParams = this.rtnPartInfo;
				//벨리데이션 체크
				this.insVali.validateSync(saveParams);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001152'), //신청하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001276'), clickFn: this.apcn }] //신청
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async apcn() {
			const rptpNo = this.rtnPartInfo.rptpNo;
			await this.setRtnPartInfo_({ key: 'rptpSt', value: 10 });
			const updateParams = this.rtnPartInfo;

			const params = { rptpNo: rptpNo, updateParams: updateParams };

			await this.UpdateRtnPartSt_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			const rtnPartInfo = this.rtnPartInfo;
			await this.getRtnPartInfo_(rtnPartInfo);
			this.$sf_toggleLoading(false);
		},
		CmplAction() {
			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001285'), //확인완료하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001268'), clickFn: this.cmpl }] //확인완료
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async cmpl() {
			const rptpNo = this.rtnPartInfo.rptpNo;
			await this.setRtnPartInfo_({ key: 'rptpSt', value: 99 });
			const updateParams = this.rtnPartInfo;

			const params = { rptpNo: rptpNo, updateParams: updateParams };

			await this.UpdateRtnPartCmpl_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			const rtnPartInfo = this.rtnPartInfo;
			await this.getRtnPartInfo_(rtnPartInfo);
			this.$sf_toggleLoading(false);
		}
	},
	async created() {
		this.$sf_toggleLoading(true);
		await this.getCommCodes_({ key: 'clctWayList', codeType: 'CLCT_WAY' }); //수요상태 콤보박스
		this.rtnPartInfo.sgtn == '' || this.rtnPartInfo.sgtn == null
			? await this.setRtnPartInfo_({ key: 'sgtn', value: this.getMessage_('QWCC001500') })
			: this.rtnPartInfo.sgtn;
		this.$sf_toggleLoading(false);
	},
	watch: {}
};
</script>
